export default "__VITE_ASSET__Rn$E$BHW__"